'use client'
import React, {useContext, useMemo} from 'react'
import classnames from 'classnames'
import type {LinkProps} from 'next/link'

import {Context} from '../../../Header/Context'
import {useIsOnMobile} from '../../../hooks/useIsOnMobile'
import {useModalsContext} from '../../../hooks/useModalContext'
import {useParams} from '../../../hooks/useParams'
import {addParamsToUrl} from '../../../utils/addParamsToUrl'
import {btn} from '../../styleGenerators/button'
import type {TButtonProps} from '../Button/Button'
import {Icon} from '../Icon/Icon'

import btnStyles from '../../styleGenerators/button/styles.module.css'

export function LinkButton(props: TButtonProps & LinkProps & {goal?: string}) {
  const {
    href,
    size = 'm',
    goal,
    onClick: onClickExternal,
    stretchToFillContainer,
    shape = 'rounded',
    variant = 'primary',
    icon,
    iconPosition = 'right',
    iconColor,
    isIconAbsolutePos = false,
    typographyProps,
    children,
    className,
    iconSize: _iconSize, //iconSize передается в ссылку, где он не должен быть, поэтому надо его заигнорить
    ...linkProps
  } = props
  const {reachGoal} = useContext(Context)
  const {params} = useParams()
  const {dispatch} = useModalsContext()
  const stringHref = useMemo(() => addParamsToUrl(href?.toString() || '', params), [params, href])
  const isOnMobile = useIsOnMobile()
  const isModal = href?.toString().includes('$modal:')
  const hrefSegments = isModal ? href.toString().split(':') : []

  return (
    <a
      className={classnames(
        btn({
          isLink: true,
          variant,
          size,
          stretchToFillContainer,
          shape,
          ...(typographyProps ? typographyProps : {}),
          className,
        }),
        className,
      )}
      href={isModal && hrefSegments.length === 3 && !isOnMobile ? hrefSegments[2] : stringHref}
      onClick={e => {
        if (isModal && (isOnMobile || hrefSegments.length !== 3)) {
          e.preventDefault()
          dispatch({type: 'setOpen', payload: hrefSegments[1]})
        }

        goal && reachGoal?.(goal)
        onClickExternal?.(e)
      }}
      {...linkProps}
    >
      {iconPosition === 'right' && children}
      {icon && (
        <Icon
          name={icon}
          {...(iconColor ? {color: iconColor} : {})}
          className={classnames(btnStyles[`${iconPosition}${isIconAbsolutePos ? 'Edge' : ''}`])}
        />
      )}
      {iconPosition === 'left' && children}
    </a>
  )
}
